import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-zero': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8c141.8 0 248.4 110.1 248.4 248 0 147.1-118.5 248-248.4 248-134 0-247.6-109.5-247.6-248 0-132.9 104.7-248 247.6-248zM248.4 52.7c-118.2 0-203.7 97.9-203.7 203.3 0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8 0.1-113.8-90.2-203.3-202.8-203.3zM248 113.2c81.9 0 102.5 77.3 102.5 142.8s-20.6 142.8-102.5 142.8-102.5-77.3-102.5-142.8 20.6-142.8 102.5-142.8zM248 167.1c-42.1 0-44.1 60.1-44.1 88.9 0 9.3 0.2 21.7 1.9 34.4l54.5-100.2c5.7-9.8 2.8-16.8-3.1-21.9-2.8-0.7-5.9-1.2-9.2-1.2zM288.8 213.3l-60.9 105.2c-12.5 18.7 6.6 26.4 20.1 26.4 42.1 0 44.1-60 44.1-88.9 0-11.3-0.4-27.3-3.3-42.7z'
      }
    ]
  }
})
